var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-xl",attrs:{"elevation":"0","outlined":"","width":"100%"}},[_c('v-card-text',[_c('Line-Chart',{attrs:{"data":_vm.data,"options":_vm.options,"height":"300"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }